import { Button } from '@chakra-ui/react';
import { LuPenLine } from 'react-icons/lu';

import { SidebarRailTooltip } from '../../../SidebarRailTooltip/SidebarRailTooltip';

interface ComposeButtonProps {
  onClick: () => void;
  isLoading?: boolean;
  isOpen: boolean;
  text: string;
}

const stylesheet = {
  buttonExpanded:
    'w-full ml-0 mb-4 border-l border-t border-b border-semantic-border dark:border-transparent rounded-l-semantic rounded-r-none !py-2 !px-3 !h-11 shadow-md hover:shadow-lg dark:shadow-sm dark:hover:shadow transition-all duration-200 !font-medium',
  buttonCollapsed:
    '!w-11 !h-11 mb-4 border border-semantic-border dark:border-transparent !rounded-semantic !p-0 flex items-center justify-center shadow-md hover:shadow-lg dark:shadow-sm dark:hover:shadow transition-all duration-200',
  iconExpanded: 'mr-2',
};

export function ComposeButton({
  onClick,
  isLoading = false,
  isOpen,
  text,
}: Readonly<ComposeButtonProps>) {
  if (isOpen) {
    return (
      <Button
        onClick={onClick}
        variant="emerald"
        isLoading={isLoading}
        className={stylesheet.buttonExpanded}
      >
        <LuPenLine className={stylesheet.iconExpanded} />
        {text}
      </Button>
    );
  }

  return (
    <SidebarRailTooltip label={text}>
      <Button
        onClick={onClick}
        variant="emerald"
        isLoading={isLoading}
        className={stylesheet.buttonCollapsed}
        aria-label={text}
      >
        <LuPenLine />
      </Button>
    </SidebarRailTooltip>
  );
}
